<template>
    <div class="form__section">
        <div class="row">
            <div class="col-12">
                <div class="form-section__header">
                    <h2 class="title title--3">{{ formLabels.title }}</h2>
                    <p v-if="formLabels.description">{{ formLabels.description }}</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group form-group--checkbox-row">
                    <div class="form-field form-field--checkbox">
                        <input v-model="formData.benefit.action" :value="formLabels.fields.benefitAction1" id="benefitAction1" type="radio" />
                        <label for="benefitAction1">{{ formLabels.fields.benefitAction1 }}</label>
                    </div>
                    <div class="form-field form-field--checkbox">
                        <input v-model="formData.benefit.action" :value="formLabels.fields.benefitAction2" id="benefitAction2" type="radio" />
                        <label for="benefitAction2">{{ formLabels.fields.benefitAction2 }}</label>
                    </div>
                    <span class="form-group__error" v-if="$v.formData.benefit.action.$error">Please select an option</span>
                    <span class="form-group__detail" v-if="formData.benefit.action === formLabels.fields.benefitAction2 && formLabels.fields.benefitAction2Detail">{{ formLabels.fields.benefitAction2Detail }}</span>
                </div>
            </div>
        </div>
        <div class="row" v-if="formData.benefit.action && formData.benefit.action !== formLabels.fields.benefitAction2">
            <div class="col-12">
                <h3>Select your membership type</h3>
            </div>
            <div class="col-12">
                <div class="form-group form-group--checkbox-row">
                    <div class="form-field form-field--checkbox">
                        <input v-model="formData.benefit.type" :value="formLabels.fields.benefitType1" id="benefitType1" type="radio" />
                        <label for="benefitType1">{{ formLabels.fields.benefitType1 }}</label>
                    </div>
                    <div v-if="formLabels.fields.benefitType2" class="form-field form-field--checkbox">
                        <input v-model="formData.benefit.type" :value="formLabels.fields.benefitType2" id="benefitType2" type="radio" />
                        <label for="benefitType2">{{ formLabels.fields.benefitType2 }}</label>
                    </div>
                    <div v-if="formLabels.fields.benefitType3" class="form-field form-field--checkbox">
                        <input v-model="formData.benefit.type" :value="formLabels.fields.benefitType3" id="benefitType3" type="radio" />
                        <label for="benefitType3">{{ formLabels.fields.benefitType3 }}</label>
                    </div>
                    <div v-if="formLabels.fields.benefitType4" class="form-field form-field--checkbox">
                        <input v-model="formData.benefit.type" :value="formLabels.fields.benefitType4" id="benefitType4" type="radio" />
                        <label for="benefitType4">{{ formLabels.fields.benefitType4 }}</label>
                    </div>
                    <div v-if="formLabels.fields.benefitType5" class="form-field form-field--checkbox">
                        <input v-model="formData.benefit.type" :value="formLabels.fields.benefitType5" id="benefitType5" type="radio" />
                        <label for="benefitType5">{{ formLabels.fields.benefitType5 }}</label>
                    </div>
                    <div v-if="formLabels.fields.benefitType6" class="form-field form-field--checkbox">
                        <input v-model="formData.benefit.type" :value="formLabels.fields.benefitType6" id="benefitType6" type="radio" />
                        <label for="benefitType6">{{ formLabels.fields.benefitType6 }}</label>
                    </div>
                    <span class="form-group__error" v-if="$v.formData.benefit.type.$error">Please select an option</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    props: {
        formLabels: {
            type: Object,
            required: true
        }
    },
    inject: ['$v'],
    computed: {
        ...mapGetters(['formData','formSummary']),
        benefitFields() {
            return this.formSummary[1].fields;
        }
    },
    watch: {
        'formData.benefit.action': {
            handler: function(newVal) {
                
                if(newVal !== this.formLabels.fields.benefitAction1) {

                    if(this.formData.benefit.type) {
                        this.formData.benefit.type = undefined;
                        this.formSummary[1].fields['NCT Card type'] = undefined;
                    }
                }
            }
        },
        'formData.benefit': {
            handler: function(newVal) {
                this.buildSummary(newVal);
            },
            deep: true
        }
    },
    methods: {
        buildSummary(fieldData) {
            let prettyLabels = {
                    action: 'NCT Card action',
                    type: 'NCT Card type'
                };

            this.formSummary[1].title = this.formLabels.title;

            for(let key of Object.keys(fieldData)) {
                let label = this.formLabels[key];

                if(label) {
                    this.benefitFields[label] = fieldData[key];
                } else if(prettyLabels[key]) {
                    this.benefitFields[prettyLabels[key]] = fieldData[key];
                }
            }
        }
    },
    mounted() {
        this.formSummary.push({
            fields: {}
        });
    }    
}
</script>